// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2jjej","file":"styles_file__3GM9J"};